export default "__VITE_ASSET__CMIcTZcV__"